import Bus from "./bus";

export function asyncModal(options = {}) {
  return new Promise(resolve => {
    options.onClose = options.onDismiss = data => resolve(data);
    Bus.$emit("new", options);
  });
}
